import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import axios from 'axios';
import Swal from 'sweetalert2';

const Freeregistration = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [pinsData, setPinsData] = useState([]);
  const [submittedEmailId, setSubmittedEmailId] = useState('');

  useEffect(() => {
    // Disable scrolling on the HTML and body elements on mobile screens
    if (window.innerWidth <= 768) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    // Re-enable scrolling when the component unmounts
    return () => {
      document.documentElement.style.overflow = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleSubmit = async () => {
    if (email.trim() === '') {
      setError('Please enter an Email ID');
    } else {
      setError('');

      try {
        const response = await axios.post(
          'https://apimlm.bloomitsolutions.in/ferrpinrotes/generate-pin',
          { email }
        );
        const generatedPin = response.data;

        setPinsData([...pinsData, generatedPin]);
        setEmail('');
        setSubmittedEmailId(email);

        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Email and PIN stored successfully.',
        });
      } catch (error) {
        console.error('Error generating free PIN:', error);
      }
    }
  };

  return (
    <Container>
      <div className="card border-0 shadow mt-5 mb-4">
        <div className="card-header bg-info border-0">
          <h4>Free Registration Details</h4>
        </div>
        <Row>
          <Col lg={6} md={12}>
            <div className="card m-5 bg-primary">
              <div className="card-body bg-danger text-white m-5">
                <h1>Package - 999</h1>
              </div>
            </div>
          </Col>
          <Col lg={6} md={12}>
            {/* You can uncomment this section for the second column if needed */}
            {/* <div className="card m-5 bg-danger">
              <div className="card-body bg-primary text-white m-5">
                <h1>Package - 600</h1>
              </div>
            </div> */}
          </Col>
        </Row>
        <div className="col-lg-12 p-3">
          <label htmlFor="exampleInputPassword1" className="form-label">
            Email ID
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Email ID"
            id="exampleInputPassword1"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="col-lg-12 p-3">
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <button className="btn btn-primary" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </Container>
  );
};

export default Freeregistration;
